module.exports = __webpack_public_path__ + "img/oie-produkt-03.jpg";